import React, { Dispatch, SetStateAction } from 'react';
import { CompleteOperationType, StartOperationType } from '../../../../../../model/alerts.model';
import CustomPopOver from '../../../../../shared/CustomPopOver/CustomPopOver';
import { ProvisionalEvent } from '../../CalendarGrid';
import { EventFormContainer } from './EventFormContainer';

interface EventCreationPopOverProps {
  provisionalEvent?: ProvisionalEvent | null;
  anchorEl: HTMLDivElement | null;
  onClose: () => void;
  setProvisionalEvent?: React.Dispatch<React.SetStateAction<ProvisionalEvent | null>>;
  data?: any;
  isEditingExisting: boolean;
  setIsEditingExisting: Dispatch<SetStateAction<boolean>>;
  startOperation: StartOperationType;
  completeOperation: CompleteOperationType;
}

export const EventCreationPopOver = ({
  provisionalEvent,
  anchorEl,
  onClose,
  setProvisionalEvent,
  data,
  isEditingExisting,
  setIsEditingExisting,
  startOperation,
  completeOperation,
}: EventCreationPopOverProps) => {
  return (
    <CustomPopOver
      anchorEl={anchorEl}
      vertical='center'
      horizontal='left'
      setAnchorEl={onClose}
      id='simple-popover'
      sx={{
        borderRadius: '14px',
        boxShadow: 'rgba(0, 0, 0, 0.15)',
        marginLeft: '-390px',
      }}
    >
      <EventFormContainer
        data={data}
        isEditingExisting={isEditingExisting}
        provisionalEvent={provisionalEvent}
        onClose={onClose}
        setProvisionalEvent={setProvisionalEvent}
        setIsEditingExisting={setIsEditingExisting}
        startOperation={startOperation}
        completeOperation={completeOperation}
      />
    </CustomPopOver>
  );
};
